import {
  ACCOUNT_DASHBOARD, STASH, MODULE_CLICK, NOT_APPLICABLE
} from '../constants';
import { getPageType, isAccountDashboard } from '../page-context';

export const userListsCarousel = () => {
  const publishAnalytics = (output) => {
    // The component hardcodes "workspace dashboard", so the account dashboard overrides it; every
    // other page keeps whatever the component sent.
    const {
      widgetTemplates,
      widgetCampaign,
      widgetComponent,
    } = output;
    const ddoEvent = {
      category: {
        primaryCategory: STASH,
      },
      eventInfo: {
        eventName: MODULE_CLICK,
      },
      eventMode: STASH,
      stash: {
        pageType: getPageType(),
        content: {
          widgets: [{
            action: NOT_APPLICABLE,
            id: 'lists',
            name: NOT_APPLICABLE,
            templates: isAccountDashboard() ? ACCOUNT_DASHBOARD : widgetTemplates,
            campaign: widgetCampaign,
            component: widgetComponent,
            element: 'lists'
          }]
        }
      },
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  };

  window.LIFE_CYCLE_EVENT_BUS.on('user-lists-carousel.viewSelectedLists', ({ output = {} }) => {
    publishAnalytics(output);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('user-lists-carousel.viewAllLists', ({ output = {} }) => {
    publishAnalytics(output);
  });
};